<template>
  <div id="app" class="container-fluid">
    <h1>CI-HMT Leipzig</h1>
    <router-view></router-view>  
    </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue